import * as yup from 'yup'

const schema = yup.object().shape({
  name: yup.string().required(),
  email: yup.string().email().required(),
  phone: yup.string().required(),
  document: yup.string().required(),

  companyName: yup.string().required(),
  segment: yup.string().required(),
  employees: yup.string().required(),
})

export default schema
